import React from 'react'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default ({ data: { file } }) => (
  <div className="container py-16 mx-auto max-w-3xl px-3">
    <div className="flex justify-center">
      <div className="flex flex-col">
        <Img
          fluid={file.childImageSharp.fluid}
          className="rounded-full w-32 mx-auto"
          alt="Photo de profil"
        />

        <h1 className="mr-4 text-3xl text-gray-700 font-normal mt-4">
          <span className="font-extrabold text-black">Hồ Văn Chương</span>
        </h1>
      </div>
    </div>

    <div className="post-content text-gray-700">
      <p>
        Chào mừng các bạn đã ghé thăm blog, đây là nơi chia sẻ kinh nghiệm, học thuật, vấn đề chuyên môn với các phần mềm kỹ thuật.Bạn có thể tìm thấy các giải pháp tự động, công nghệ mới cũng như lập trình trong thời gian nghiên cứu của mình ở mục <Link to="/articles">Articles</Link> về các chủ đề khác nhau trên trang cá nhân này.
      </p>

      <p>
        Mình làm việc trên các{' '}
        <a href="https://github.com/chuongmep">Dự án mã nguồn mở</a>{' '}
        mà bạn có thể tìm thấy trên Github.
      </p>


      <p>
        Thời gian rảnh rỗi mình nghiên cứu công nghệ mới và chụp ảnh trắng đen,đôi khi có chút màu sắc. Có thể tìm thấy các hình ảnh trong mục {' '}
        <Link to="/photos">Photos</Link> để hiểu hơn trong lúc mình viết blog , nghiên cứu, làm việc, hỗ trợ thả thính khắp nơi trên diễn đàn.
      </p>

      <p>
        Hiện tại mình đang sinh sống và làm việc tại <a href="https://vi.wikipedia.org/wiki/Singapore" target="_blank">Singapore</a>, bạn có thể kết nối với mình công việc hoặc hỗ trợ lỗi thông qua {' '}
        <a href="https://www.linkedin.com/in/chuongmep/">Linkedin</a> ! 👋
      </p>

      <div className="flex justify-center my-8">
        <div className="w-full md:w-1/2 flex justify-between flex-wrap">
          <p className="w-1/2 md:w-auto text-center sm:mt-0 mt-4">
            <a href="https://github.com/chuongmep/">
              <FontAwesomeIcon
                icon={['fab', 'github']}
                className="text-indigo-500 mr-1"
              />{' '}
              GitHub
            </a>
          </p>

          <p className="w-1/2 md:w-auto text-center sm:mt-0 mt-4">
            <a href="https://twitter.com/chuongmep">
              <FontAwesomeIcon
                icon={['fab', 'twitter']}
                className="text-indigo-500 mr-1"
              />{' '}
              Twitter
            </a>
          </p>

          <p className="w-1/2 md:w-auto text-center sm:mt-0 mt-4">
            <a href="https://www.instagram.com/c00100011/">
              <FontAwesomeIcon
                icon={['fab', 'instagram']}
                className="text-indigo-500 mr-1"
              />{' '}
              Instagram
            </a>
          </p>

          <p className="w-1/2 md:w-auto text-center sm:mt-0 mt-4">
            <a href="https://www.linkedin.com/in/chuongmep/">
              <FontAwesomeIcon
                icon={['fab', 'linkedin']}
                className="text-indigo-500 mr-1"
              />{' '}
              Linkedin
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
)

export const query = graphql`
  {
    file(relativePath: { eq: "me.jpg" }) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 128, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
